import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarNameModule } from '@vueling-ng/vy-ds/src/lib/components/globals/avatar-name';
import { BadgeModule } from '@vueling-ng/vy-ds/src/lib/components/globals/badge';
import { BoxModule } from '@vueling-ng/vy-ds/src/lib/components/globals/box';
import { ButtonModule } from '@vueling-ng/vy-ds/src/lib/components/globals/button';
import { ChipModule } from '@vueling-ng/vy-ds/src/lib/components/globals/chip';
import { InputModule } from '@vueling-ng/vy-ds/src/lib/components/globals/forms/input';
import { SelectModule } from '@vueling-ng/vy-ds/src/lib/components/globals/forms/select';
import { IconTextModule } from '@vueling-ng/vy-ds/src/lib/components/globals/icon-text';
import { ListModule } from '@vueling-ng/vy-ds/src/lib/components/globals/list';
import { LoaderModule } from '@vueling-ng/vy-ds/src/lib/components/globals/loaders/loader';
import { MenuHorizontalComponent } from '@vueling-ng/vy-ds/src/lib/components/globals/menu-horizontal';
import { PaginatorModule } from '@vueling-ng/vy-ds/src/lib/components/globals/paginator';
import { SegmentedControlsComponent } from '@vueling-ng/vy-ds/src/lib/components/globals/segmented-controls';
import { TableModule } from '@vueling-ng/vy-ds/src/lib/components/globals/table';
import { TextLinkModule } from '@vueling-ng/vy-ds/src/lib/components/globals/text-link';
import { UrlBuilderModule } from 'app/shared/pipes/url-builder.module';
import { MarkdownModule } from 'ngx-markdown';
import { BookingTableComponent } from './components/booking-table/booking-table.component';
import { ExportBookingListComponent } from './components/export-booking-list/export-booking-list.component';
import { FilterPanelComponent } from './components/filter-panel/filter-panel.component';

@NgModule({
  declarations: [FilterPanelComponent],
  imports: [
    CommonModule,
    TableModule,
    PaginatorModule,
    ButtonModule,
    InputModule,
    ReactiveFormsModule,
    RouterModule,
    BadgeModule,
    UrlBuilderModule,
    TranslateModule,
    MarkdownModule,
    ListModule,
    BoxModule,
    TextLinkModule,
    MenuHorizontalComponent,
    AvatarNameModule,
    IconTextModule,
    LoaderModule,
    SelectModule,
    SegmentedControlsComponent,
    ChipModule,
    BookingTableComponent,
    ExportBookingListComponent
  ]
})
export class BookingListModule {}
